export default {
  'currentUser.set': (state, { user, credentials }) => {
    state.user = user ? {
      ...user,
      id: credentials.identityId
    } : null
  },
  'profile.set': (state, profile) => {
    state.profile = profile
  }
}
